export default __webpack_public_path__ + "static/media/medical_5.83e53235.jpg";